import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import './Portfolio.css'
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
export default class Portfolio extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  constructor(props) {
    super(props);
    this.state = {
      projects: [
        {
          id: 'fmd',
          image: './assets/images/mockup.png',
          logo: '../assets/projects-logo/find-my-doc/logo.png',
          logoClass: 'project-logo-fmd',
          title: 'A dynamic medical booking management platform connecting',
          subtitle: 'patients with doctors and hospitals digitally.',
          description: 'We built a comprehensive doctor channeling and medical center management solution that connects patients, doctors, and hospitals in one platform. With smart features like medical records, online booking, and family profiles, FMD enhances healthcare accessibility across Sri Lanka.',
          link: '/project-view/sub-project?project=fmd'
        },
        {
          id: 'rcgc',
          image: './assets/images/rcgcMobileLogo.png',
          logo: '../assets/projects-logo/rcgc/logo.png',
          logoClass: 'project-logo-rcgc',
          title: 'Developed a user-friendly website for the prestigious',
          subtitle: 'Royal Colombo Golf Club, enhancing their online presence and member engagement.',
          description: 'Ambrum redesigned the Royal Colombo Golf Club\'s official website with a clean, responsive layout that highlights tradition and prestige while enabling smooth event updates, member login, and contact features to elevate user experience.',
          link: '/project-view/sub-project?project=rcgc'
        },
        {
          id: 'volt-charge',
          image: './assets/images/voltChargeLogo.png',
          logo: '../assets/projects-logo/volt-charge/logo.png',
          logoClass: 'project-logo-vc',
          title: 'VoltCharge – Powering the Future of Electric Mobility',
          subtitle: 'An intelligent EV charging ecosystem designed for convenience, sustainability, and scalability.',
          description: 'VoltCharge is a cutting-edge EV charging solution designed to accelerate sustainable mobility. Built with intelligent backend systems and a user-friendly interface, it supports seamless station management, user payments, and real-time tracking, empowering Sri Lanka\'s growing electric vehicle infrastructure.',
          link: '/project-view/sub-project?project=volt-charge'
        },
        {
          id: 'lets-talk',
          image: './assets/images/letstalkLogo.png',
          logo: '../assets/projects-logo/lets-talk/logo.png',
          logoClass: 'project-logo-lt',
          title: 'Let\'s Talk – Australia\'s Smart Consultation & Appointment App',
          subtitle: 'Empowering professionals and clients to connect, consult, and schedule with ease—anytime, anywhere.',
          description: 'Let\'s Talk is a smart consultation and scheduling app based in Australia. It bridges professionals and clients across sectors, offering effortless appointment booking, secure communication, and calendar integration, all in one sleek and reliable mobile platform.',
          link: '/project-view/sub-project?project=lets-talk'
        },
        {
          id: 'port-city',
          image: './assets/images/portCityLogo1.png',
          logo: '../assets/projects-logo/port-city/logo.png',
          logoClass: 'project-logo-pc',
          title: 'PortCity App – Your Gateway to Smart Urban Living',
          subtitle: 'A fully integrated app designed for residents, visitors, and service providers within Port City Colombo.',
          description: 'The PortCity App centralizes life in Sri Lanka\'s most ambitious smart city. Designed for residents, service providers, and administrators, the app enables access to city services, navigation, payments, and more, delivering a world-class urban digital experience',
          link: '/project-view/sub-project?project=port-city'
        }
      ]
    };
  }


  render() {
    return (
      <div>
        <Container className="mt-9">
          <div className="hero-text-2 text-center">
            <p>
              <span className="hero-text-color-1">Transforming</span> Ideas into
              <br />
              Impactful
              <span className="hero-text-color-1">Digital Realities</span>
            </p>
          </div>
          <p className="text-center">
            At Ambrum, we transform ambitious ideas into digital realities <br />
            blending smart software solutions with impactful marketing to shape
            the future of business.
          </p>

          {/* <div className="d-flex mt-5  filter-section">
            <p className="filter-text my-auto ">Filters:</p>
            <div className=" col-lg-3 col-md-5 col-sm-6 col-6 mx-2">
              <select className=" form-select">
                <option value="" disabled selected hidden className="placeholder-option">
                  Industry
                </option>

                <option value="healthcare" className="my-2">Healthcare</option>
                <option value="aviation" className="my-2">Aviation</option>
                <option value="finance" className="my-2">Legal Services</option>
                <option value="technology" className="my-2">Retail & E-commerce</option>
                <option value="technology" className="my-2">Sports & Recreation</option>
                <option value="technology" className="my-2">Technology</option>
              </select>
            </div>
            <div className="col-lg-3 col-md-5 col-sm-6 col-6 mx-2">
              <select className=" form-select">
                <option value="" disabled selected hidden className="filter-text">Project Type</option>

                <option value="healthcare" className="my-2">Mobile Applications​</option>
                <option value="aviation" className="my-2">Web Development</option>
                <option value="finance" className="my-2">E-commerce Solutions</option>
                <option value="technology" className="my-2">Brand Strategy</option>
                <option value="technology" className="my-2">Digital Marketing Campaigns</option>
                <option value="technology" className="my-2">Enterprise Solutions</option>
              </select>
            </div>

          </div> */}


          <div className="projects-page">

            <div className="projects-container">
              {this.state.projects.map((project) => (
                <div className="project-card py-5 mt-5" key={project.id}>
                  <div className="image-section">
                    <img src={project.image} alt="Project Screenshot" />
                  </div>
                  <div className="content-section">
                    {project.logoClass && (
                      <div className="d-flex">
                        <img className={project.logoClass} src={project.logo} alt="" />
                      </div>
                    )}
                    <h3>
                      {project.title}
                      <br />
                      {project.subtitle}
                    </h3>
                    <p className="description">
                      {project.description}
                    </p>
                    <Link to={project.link} className="project-link">
                      View Project &gt;
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>


        <ContactUsFooter />
        <br />
        <Footer />
      </div>

    );
  }
}
